import React from "react";
import ArrowRight from "../../../assets/svg/arrowRight.svg";

export default function ListArrow({ className, clickHandler }) {
  return (
    <div className={className} onClick={clickHandler} data-testid="list-arrow">
      <ArrowRight />
    </div>
  );
}
